/**
 * Building a Drive link from a stored file id.
 *
 * `IDriveNode.drive_url` is the safe path and should be preferred wherever a
 * node is in hand: ancana_api builds it, and the browser does not have to
 * decide anything. This exists for the places that only kept the id —
 * `FloorPlanRender.source_file_id` and `FloorPlan.source_file_id`, denormalised
 * at publish time so a published image's provenance outlives the render.
 *
 * The pattern check is the whole point. Those columns are `CharField`s fed from
 * Pathfinder, and an href assembled from unvalidated stored text is how a
 * `javascript:` or `data:` URL reaches an anchor. A Drive id is an opaque
 * base64url token, so anything outside that alphabet is not one and gets no
 * link at all.
 */
const DRIVE_ID = /^[A-Za-z0-9_-]{10,200}$/;

export const driveFileUrl = (fileId?: string | null): string | undefined =>
  (fileId && DRIVE_ID.test(fileId)
    ? `https://drive.google.com/file/d/${fileId}/view`
    : undefined);

export default driveFileUrl;
